import { Fragment } from 'react';

import type { ReactNode } from 'react';

interface ParseLineParams {
    line: string;
    lineKey: number;
}

const parseInlineMarkdown = ({ line, lineKey }: ParseLineParams): ReactNode[] => {
    const regex = /(\*\*[^*\n]+\*\*|\*[^*\n]+\*)/g;
    const parts: ReactNode[] = [];
    let lastIndex = 0;

    for (const match of line.matchAll(regex)) {
        const matchIndex = match.index ?? 0;

        if (matchIndex > lastIndex) {
            parts.push(line.slice(lastIndex, matchIndex));
        }

        const raw = match[0];

        if (raw.startsWith('**')) {
            parts.push(<strong key={`${lineKey}-bold-${matchIndex}`}>{raw.slice(2, -2)}</strong>);
        } else {
            parts.push(<em key={`${lineKey}-em-${matchIndex}`}>{raw.slice(1, -1)}</em>);
        }

        lastIndex = matchIndex + raw.length;
    }

    if (lastIndex < line.length) {
        parts.push(line.slice(lastIndex));
    }

    return parts;
};

export interface QuestionTextRendererProps {
    text: string;
}

const QuestionTextRenderer = ({ text }: QuestionTextRendererProps) => {
    const lines = text.split('\n');

    return (
        <>
            {lines.map((line, index) => (
                <Fragment key={index}>
                    {index > 0 && <br />}

                    {parseInlineMarkdown({ line, lineKey: index })}
                </Fragment>
            ))}
        </>
    );
};

export { QuestionTextRenderer };
